import { Link } from "react-router-dom";
import { KONTAKT, KONTAKT_LANK, PRODUKT } from "../../lib/config";
import { Ikon } from "../Ikon";
import { HeroAgent } from "./HeroAgent";

export function Hero() {
  return (
    <section className="hero">
      <div className="wrap">
        <div className="copy">
          <span className="eyebrow">Leverantörsreskontra i agentläge</span>
          <h1>Varje faktura granskad <em>innan den når attest.</em></h1>
          <p className="lead">{PRODUKT} är byggd för ekonomiavdelningar med många leverantörsfakturor. Agenten läser varje faktura, kontrollerar den mot leverantörsregistret och konterar den. Det som inte går att lita på stoppas med orsaken angiven. Resten går till attest, med det som ska bekräftas utpekat.</p>
          <div className="ctas">
            {KONTAKT ? <a className="btn primary" href={KONTAKT_LANK}>Boka en genomgång <Ikon namn="arrow" /></a> : null}
            <a className={"btn" + (KONTAKT ? "" : " primary")} href="#sa-fungerar-det">Se hur det fungerar</a>
            <Link className="btn ghost" to="/logga-in">Logga in</Link>
          </div>
          <dl className="facts">
            <div><dt>fakturor i piloten</dt><dd>1&nbsp;249</dd></div>
            <div><dt>kontroller per faktura</dt><dd>~40</dd></div>
            <div><dt>attester eller betalningar gjorda av agenten</dt><dd>0</dd></div>
          </dl>
        </div>
        <HeroAgent />
      </div>
    </section>
  );
}
